﻿function cac_enquiryCarOptions() {
    globalThis.cac_data = (typeof globalThis.cac_data === "undefined") ? {} : globalThis.cac_data;

    const enquiryCar = {
        capId: currentPageCapId,
        transmission: '',
        make: '',
        model: '',
        derivative: ''
    };
    const enquiryCarSetValues = function (val) {
        const valArr = val.split('|');
        enquiryCar.capId = valArr[0];
        enquiryCar.make = valArr[1];
        enquiryCar.model = valArr[2];
        enquiryCar.derivative = valArr[3];

    }

    const enquiryCar_updateSelectedLabel = {
        makeModel: function (val) {
            enquiryCarSelectedMakeModel.textContent = val;
        },
        derivative: function (val) {
            enquiryCarSelectedDerivative.textContent = val;
        }
    }

    const enquiryForm = document.querySelector('[data-form-enquiry]');
    const enquiryTransmissionRadios = document.querySelectorAll('#enquiry-car-select-transmission input[name="Transmission"]');
    const enquiryMakeSelect = document.getElementById("enquiry-car-select-make");
    const enquiryModelSelect = document.getElementById("enquiry-car-select-model");
    const enquiryDerivativeSelect = document.getElementById("enquiry-car-select-derivative");
    const enquiryCarOther = document.getElementById("enquiry-car-other");
    const enquiryCarNotsure = document.getElementById("NotSureWhichCar");
    const enquiryCarOptionsTemplate = document.getElementById("enquiry-car-select-options");

    const enquiryCarSelectContainer = document.querySelector('.form-component--car-select.item-container');
    const enquiryCarSelectFirstItem = document.querySelector('.form-component--car-select .form-input-group-item:first-of-type');
    const enquiryCarSelectChange = document.querySelector('.enquiry-selected-car--change');
    const enquiryCarSelectChangeDone = document.querySelector('.enquiry-selected-car--done');
    const enquiryCarSelectChangeReset = document.querySelector('.enquiry-selected-car--reset');

    enquiryCarSelectChange.addEventListener('click', function () {
        enquiryCarSelectContainer.classList.add('active');
        if (enquiryCarSelectFirstItem) enquiryCarSelectFirstItem.focus();
    });
    enquiryCarSelectChangeDone.addEventListener('click', function () {
        enquiryCarSelectContainer.classList.remove('active');
        enquiryCarSelectChange.focus();
    });
    enquiryCarSelectChangeReset.addEventListener('click', function () {
        enquiryCarOptionsInnit();
    });
    enquiryCarSelectContainer.addEventListener('keydown', function (event) {
        //if (event.defaultPrevented) {
        //    return; // Do nothing if the event was already processed
        //}
        switch (event.key) {
            case 'Enter':
                if (event.target.matches('button')) return;
                enquiryCarSelectChangeDone.click();
                break;
            case 'Escape':
                enquiryCarSelectChangeDone.click();
                break;
            default:
                return;

        }
        event.stopPropagation();
        event.preventDefault();
    });

    const enquiryCarSelectedLabel = document.querySelector('.enquiry-selected-car.item-container');
    const enquiryCarSelectedMakeModel = document.querySelector('.enquiry-selected-car--make-model');
    const enquiryCarSelectedDerivative = document.querySelector('.enquiry-selected-car--derivative');

    enquiryCarSelectedLabel.addEventListener('click', function () {
        enquiryCarSelectContainer.classList.add('active');
    });

    const enquiryCallbackNone = document.getElementById("NoCallback");
    const enquiryCallbackDay = document.getElementById("CallbackPreferredDay");
    const enquiryCallbackTime = document.getElementById("CallbackPreferredTime");

    const enquiryCarOptions = enquiryCarOptionsTemplate.content.cloneNode(true);
    console.log(enquiryCarOptions.children);

    const vehicleEnquiryFields = {
        make: enquiryForm.querySelector('[data-enquiry-manufacturer]'),
        model: enquiryForm.querySelector('[data-enquiry-model]'),
        derivative: enquiryForm.querySelector('[data-enquiry-derivative]'),
        colour: enquiryForm.querySelector('[data-enquiry-colour]'),
        saleContract: enquiryForm.querySelector('[data-enquiry-sale-contract]')
    }

    function emptyOption(optionText = null) {
        const opt = document.createElement('option');
        opt.classList.add('placeholder');
        opt.setAttribute('value', '');
        if (optionText != null) {
            opt.textContent = optionText;
        } else {
            opt.innerHTML = "Please select&hellip;";
        }
        return opt;
    }

    function enquiryMakeInit() {
        cac_util.empty(enquiryMakeSelect);
        cac_util.empty(enquiryModelSelect);
        cac_util.empty(enquiryDerivativeSelect);

        const transmissionNotSpecified = enquiryCar.transmission == "Any";

        enquiryCarOther.value = "";
        enquiryCarNotsure.checked = false;
        const firstMakeOptionText = transmissionNotSpecified ? null : `Any ${enquiryCar.transmission.toLowerCase()}`;
        enquiryMakeSelect.appendChild(emptyOption(firstMakeOptionText));
        const matchingMakeOptions = enquiryCarOptions.querySelectorAll(`[data-type="make"][data-include=true]`);
        enquiryMakeSelect.removeAttribute('disabled');
        for (const opt of matchingMakeOptions) {
            const optClone = opt.cloneNode(true);
            enquiryMakeSelect.appendChild(optClone);
        }
        vehicleEnquiryFields.make.value = "";

        const makeModelLabelText = transmissionNotSpecified ? "I'm not sure yet" : `Any ${enquiryCar.transmission.toLowerCase()}`;
        //enquiryMakeSelect.options[0].textContent = `Any ${enquiryCar.transmission.toLowerCase()}`;
        enquiryCar_updateSelectedLabel.makeModel(makeModelLabelText);
        enquiryCar_updateSelectedLabel.derivative("");
    }

    function enquiryMakeGetOptions() {
        const transmission = enquiryForm.elements["Transmission"].value;
        const selectedOption = enquiryMakeSelect.selectedOptions[0];
        const selectedMake = selectedOption.value || null;

        const transmissionNotSpecified = enquiryCar.transmission == "Any";


        console.log('selectedMake');
        console.log(selectedMake);

        cac_util.empty(enquiryModelSelect);
        cac_util.empty(enquiryDerivativeSelect);

        if (selectedMake === null) {
            enquiryModelSelect.setAttribute('disabled', 'disabled');
            vehicleEnquiryFields.make.value = "";
        }
        else {
            enquiryCarOther.value = "";
            enquiryCarNotsure.checked = false;
            enquiryModelSelect.appendChild(emptyOption('Any model'));
            const matchingModelOptions = enquiryCarOptions.querySelectorAll(`[data-type="model"][data-include=true][data-make-key="${selectedMake}"]`);
            enquiryModelSelect.removeAttribute('disabled');
            for (const opt of matchingModelOptions) {
                const optClone = opt.cloneNode(true);
                enquiryModelSelect.appendChild(optClone);
            }
            vehicleEnquiryFields.make.value = selectedMake;

            const transmissionInfoText = transmissionNotSpecified ? '' : `(${enquiryCar.transmission.toLowerCase()})`;

            enquiryCar_updateSelectedLabel.makeModel(`${selectedMake} ${transmissionInfoText}`);
        }
        enquiryDerivativeSelect.setAttribute('disabled', 'disabled');
        vehicleEnquiryFields.model.value = "";
        vehicleEnquiryFields.derivative.value = "";

        enquiryCar_updateSelectedLabel.derivative("");
    }
    function enquiryModelGetOptions() {
        const selectedOption = enquiryModelSelect.selectedOptions[0];
        const selectedModel = selectedOption.value || null;
        const transmissionNotSpecified = enquiryCar.transmission == "Any";

        cac_util.empty(enquiryDerivativeSelect);


        if (selectedModel === null) {
            enquiryDerivativeSelect.setAttribute('disabled', 'disabled');
            vehicleEnquiryFields.model.value = "";
        }
        else {
            enquiryDerivativeSelect.appendChild(emptyOption('Any variant'));
            const matchingDerivativeOptions = enquiryCarOptions.querySelectorAll(`[data-type="derivative"][data-include=true][data-model-key="${selectedModel}"]`);
            enquiryDerivativeSelect.removeAttribute('disabled');
            for (const opt of matchingDerivativeOptions) {
                const optClone = opt.cloneNode(true);
                enquiryDerivativeSelect.appendChild(optClone);
            }
            vehicleEnquiryFields.model.value = selectedModel;

        }
        const transmissionInfoText = transmissionNotSpecified ? '' : `(${enquiryCar.transmission.toLowerCase()})`;
        vehicleEnquiryFields.derivative.value = "";
        enquiryCar_updateSelectedLabel.makeModel(`${vehicleEnquiryFields.make.value} ${vehicleEnquiryFields.model.value}`);
        enquiryCar_updateSelectedLabel.derivative(`${transmissionInfoText}`);
    }
    function enquiryDerivativeGetOptions() {
        const selectedOption = enquiryDerivativeSelect.selectedOptions[0];
        const selectedDerivative = selectedOption.value || null;
        if (selectedDerivative == null) {
            vehicleEnquiryFields.derivative.value = "";
            enquiryCar_updateSelectedLabel.derivative("");
        } else {
            enquiryCarSetValues(selectedDerivative);
            vehicleEnquiryFields.derivative.value = enquiryCar.derivative;

            enquiryCar_updateSelectedLabel.derivative(enquiryCar.derivative);

            const selectedDerivativeObj = cac_data.simpleMakesModels.manufacturers[selectedOption.dataset.makeKey].models[selectedOption.dataset.modelKey].derivatives.find((d) => d.capId == selectedOption.dataset.capId);
            if (selectedDerivativeObj) {
                enquiryForm.elements["Transmission"].value = selectedDerivativeObj.transmission;
            }
        }
    }

    const currentDerivative = () => {
        if (Object.hasOwn(cac_data, 'current')) {
            return Object.hasOwn(cac_data.current, 'derivative') ? cac_data.current.derivative : null;
        }
        return null;
    }

    function enquiryCarOptionsInnit() {
        if (currentPageCapId !== null) {
            const derivative = currentDerivative();
            const derivativeObj = (derivative != null) ? derivative.obj : null;
            const make = (derivativeObj != null) ? derivativeObj.manufacturerName : null;
            const isUsed = (derivativeObj != null) ? derivativeObj.isUsed : false;
            // <option 
            // data-include="true" data-type="model" 
            // data-make-key="Renault" value="Clio Diesel Hatchback" data-has-used="False">
            let modelOption = (!isUsed) 
                ? enquiryCarOptions.querySelector(`[data-type="model"][data-make-key="${make}"][value="${derivativeObj.modelName}"]`)
                : enquiryCarOptions.querySelector(`[data-type="model"][data-make-key="${make}"][value="${derivativeObj.modelName}"][data-has-used="true"]`);
            let derivativeOption = (!isUsed)
                ? enquiryCarOptions.querySelector(`[data-type="derivative"][data-cap-id="${currentPageCapId}"]`)
                : enquiryCarOptions.querySelector(`[data-type="derivative"][data-cap-id="${currentPageCapId}"][data-used="true"]`);

            if (modelOption == null) {
                modelOption = document.createElement('option');
                modelOption.setAttribute('data-used', derivativeObj.isUsed);
                modelOption.setAttribute('data-type', 'model');
                modelOption.setAttribute('data-make-key', derivativeObj.manufacturerName);
                modelOption.value = derivativeObj.modelName;
                modelOption.textContent = derivativeObj.modelName;
                modelOption.setAttribute('data-include', true);
                enquiryCarOptions.appendChild(modelOption);
            }
            if (derivativeOption == null) {
                if (derivativeObj) {
                    derivativeOption = document.createElement('option');
                    derivativeOption.setAttribute('data-used', derivativeObj.isUsed);
                    derivativeOption.setAttribute('data-type', 'derivative');
                    derivativeOption.setAttribute('data-make-key', derivativeObj.manufacturerName);
                    derivativeOption.setAttribute('data-model-key', derivativeObj.modelName);
                    derivativeOption.setAttribute('data-cap-id', derivativeObj.capId);
                    derivativeOption.setAttribute('data-include', true);

                    derivativeOption.value = `${derivativeObj.capId}|${derivativeObj.manufacturerName}|${derivativeObj.modelName}|${derivativeObj.name}`;
                    derivativeOption.textContent = derivativeObj.name;
                    if (derivativeObj.isUsed) {
                        derivativeOption.value += ' (used)';
                        derivativeOption.textContent += ' (used)';
                    }
                    enquiryCarOptions.appendChild(derivativeOption);

                    const makeSelector = `[data-type="make"][value="${derivativeObj.manufacturerName}"]`;
                    const modelSelector = `[data-type="model"][value="${derivativeObj.modelName}"]`;
                    if (enquiryCarOptions.querySelector(makeSelector) == null) {
                        makeOption = document.createElement('option');
                        makeOption.setAttribute('data-type', 'make');
                        makeOption.value = derivativeObj.manufacturerName;
                        makeOption.textContent = derivativeObj.manufacturerName;
                        enquiryCarOptions.appendChild(makeOption);
                    }
                    if (enquiryCarOptions.querySelector(modelSelector) == null) {
                        modelOption = document.createElement('option');
                        modelOption.setAttribute('data-type', 'model');
                        modelOption.setAttribute('data-make-key', derivativeObj.manufacturerName);
                        modelOption.value = derivativeObj.modelName;
                        modelOption.textContent = derivativeObj.modelName;
                        enquiryCarOptions.appendChild(modelOption);
                    }
                }
            }
            //if(derivativeOption==null && Object.hasOwn(cac_data, 'current')){
            //    if(Object.hasOwn(cac_data.current, 'derivative')){
            //        const derivativeObj = cac_data.current.derivative.obj;
            //    }
            //}

            if (derivativeObj) {
                const transmission = derivativeObj.transmission;
                enquiryForm.elements["Transmission"].value = transmission;
                enquiryCar.transmission = transmission;
                const includeAuto = transmission == "Automatic" || transmission == "Any";
                const includeManual = transmission == "Manual" || transmission == "Any";
                filterMakesByTransmission(Object.entries(cac_data.simpleMakesModels.manufacturers), includeAuto, includeManual);

                enquiryMakeInit();
            }

            if (enquiryMakeSelect.querySelectorAll('option').length > 1) {
                const selectedMakeOption = enquiryMakeSelect.querySelector(`[value="${derivativeOption.dataset.makeKey}"]`);
                selectedMakeOption.selected = true;
                enquiryMakeGetOptions();
            }
            if (enquiryModelSelect.querySelectorAll('option').length > 1) {
                const selectedModelOption = enquiryModelSelect.querySelector(`[value="${derivativeOption.dataset.modelKey}"]`);
                selectedModelOption.selected = true;
                enquiryModelGetOptions()
            }
            if (enquiryDerivativeSelect.querySelectorAll('option').length > 1) {
                const derivativeSelector = (isUsed) ? `[data-cap-id="${currentPageCapId}"][data-used="true"]` : `[data-cap-id="${currentPageCapId}"]`
                const selectedDerivativeOption = enquiryDerivativeSelect.querySelector(derivativeSelector);
                selectedDerivativeOption.selected = true;
                enquiryDerivativeGetOptions();

            }
        }
        vehicleEnquiryFields.colour.value = '';
    }

    function filterMakesByTransmission(makes, includeAuto, includeManual) {
        makes.forEach((makeItem) => {
            const make = makeItem[1];
            const option = enquiryCarOptions.querySelector(`[value="${make.name}"][data-type="make"]`);
            if (option) {
                const include = (includeAuto && make.hasAutomatic) || (includeManual && make.hasManual);
                option.setAttribute('data-include', include);
            }
            filterModelsByTransmission(make.name, make.models, includeAuto, includeManual);
        });
    }
    function filterModelsByTransmission(makeName, models, includeAuto, includeManual) {
        
        Object.entries(models).forEach((modelItem) => {
            const model = modelItem[1];
            const option = enquiryCarOptions.querySelector(`[data-make-key="${makeName}"][data-type="model"][value="${model.name}"]`);
            if (option) {
                const hasDerivativeOptions = enquiryCarOptions.querySelectorAll(`[data-model-key="${model.name}"][data-type="derivative"]`).length > 0;
                const include = hasDerivativeOptions && ((includeAuto && model.hasAutomatic) || (includeManual && model.hasManual));
                option.setAttribute('data-include', include);
            }
            const includedDerivativeCount = filterDerivativesByTransmission(model.derivatives, includeAuto, includeManual)
            if (includedDerivativeCount == 0) {
                option.setAttribute('data-include', false);
            }
        });
    }
    function filterDerivativesByTransmission(derivatives, includeAuto, includeManual) {
        let includeCount = 0;
        derivatives.forEach((derivative) => {
            const options = enquiryCarOptions.querySelectorAll(`[data-cap-id="${derivative.capId}"][data-type="derivative"]`);
            options.forEach((option) => {
                if (option) {
                    const include = (includeAuto && derivative.isAutomatic) || (includeManual && derivative.isManual);
                    option.setAttribute('data-include', include);
                    if(include) includeCount++;
                }
            });
        });
        return includeCount;
    }

    function filterByTransmission(transmission) {
        transmission = transmission || "Any";

        if (transmission == "Any") {
            enquiryMakeSelect.selectedIndex = 0;
            enquiryMakeSelect.options[0].innerHTML = "Please select&hellip;";
            enquiryCarOther.value = "";
            enquiryMakeGetOptions();
        }

        const allMakes = Object.entries(cac_data.simpleMakesModels.manufacturers);
        const makes = {
            all: allMakes,
            automatic: allMakes.filter((m) => m[1].hasAutomatic),
            manual: allMakes.filter((m) => m[1].hasManual)
        }
        

        enquiryCar.transmission = transmission;
        const includeAuto = transmission == "Automatic" || transmission == "Any";
        const includeManual = transmission == "Manual" || transmission == "Any";

        //makes.all.forEach((make) => { filterMakeByTransmission(make[1], includeAuto, includeManual); });
        filterMakesByTransmission(makes.all, includeAuto, includeManual);

        let derivativeOk = false;
        let modelOk = false;
        let makeOk = false;

        const selectedDerivative = enquiryDerivativeSelect.selectedOptions[0];
        const selectedModel = enquiryModelSelect.selectedOptions[0];
        const selectedMake = enquiryMakeSelect.selectedOptions[0];

        if (enquiryDerivativeSelect.selectedIndex > 0) {
            const derivativeCapId = selectedDerivative.dataset.capId;
            const derivativeMake = selectedDerivative.dataset.makeKey;
            const derivativeModel = selectedDerivative.dataset.modelKey;

            const selectedDerivativeObj = cac_data.simpleMakesModels.manufacturers[derivativeMake].models[derivativeModel].derivatives.find((d) => d.capId == derivativeCapId);
            if (selectedDerivativeObj) {
                derivativeOk = (includeAuto && selectedDerivativeObj.isAutomatic) || (includeManual && selectedDerivativeObj.isManual);
            }
            if (derivativeOk) {
                modelOk = true;
                makeOk = true;
            }

        }
        if (!derivativeOk && enquiryModelSelect.selectedIndex > 0) {
            const modelMake = selectedModel.dataset.makeKey;
            const modelName = selectedModel.value;
            const selectedModelObj = cac_data.simpleMakesModels.manufacturers[modelMake].models[modelName];
            if (selectedModelObj) {
                const hasDerivativeOptions = enquiryCarOptions.querySelectorAll(`[data-model-key="${modelName}"][data-type="derivative"][data-include="true"]`).length > 0;
                modelOk = hasDerivativeOptions && ((includeAuto && selectedModelObj.hasAutomatic) || (includeManual && selectedModelObj.hasManual));
            }
            if (modelOk) {
                makeOk = true;
            }
        }
        if (!derivativeOk && !modelOk && enquiryMakeSelect.selectedIndex > 0) {
            const makeName = selectedMake.value;
            const selectedMakeObj = cac_data.simpleMakesModels.manufacturers[makeName];
            if (selectedMakeObj) {
                const hasModelOptions = enquiryCarOptions.querySelectorAll(`[data-make-key="${makeName}"][data-type="model"][data-include="true"]`).length > 0;
                makeOk = hasModelOptions && ((includeAuto && selectedMakeObj.hasAutomatic) || (includeManual && selectedMakeObj.hasManual));
            }
        }


        enquiryMakeInit();
        if (makeOk) {
            const selectedMakeOption = enquiryMakeSelect.querySelector(`[value="${selectedMake.value}"]`);
            selectedMakeOption.selected = true;
            enquiryMakeGetOptions();
            if (modelOk) {
                const selectedModelOption = enquiryModelSelect.querySelector(`[value="${selectedModel.value}"]`);
                selectedModelOption.selected = true;
                enquiryModelGetOptions();
                if (derivativeOk) {
                    const isUsedValue = selectedDerivative.dataset.used;
                    /*const derivativeSelector = (isUsed) ?  : `[data-cap-id="${selectedDerivative.dataset.capId}"]`*/
                    const selectedDerivativeOption = enquiryDerivativeSelect.querySelector(`[data-cap-id="${selectedDerivative.dataset.capId}"][data-used="${isUsedValue}"]`);
                    selectedDerivativeOption.selected = true;
                    enquiryDerivativeGetOptions();
                }
            } else {
                cac_util.disableFields(enquiryDerivativeSelect);
            }
        } else {
            cac_util.disableFields([enquiryModelSelect, enquiryDerivativeSelect]);
        }
        //let exclusionQuery = null;
        //switch (transmission) {
        //    case "Any":
        //        break;
        //    case "Automatic":
        //        exclusionQuery = '[data-type="model"][],[data-type="model"]';
        //        makes.automatic.forEach((make) => {
        //            enquiryCarOptions.querySelector(`[data-type="make"][value="${make[0]}"]`).setAttribute('data-include', true);
        //        });
        //        makes.manual.forEach((make) => {
        //            enquiryCarOptions.querySelector(`[data-type="make"][value="${make[0]}"]`).setAttribute('data-include', false);
        //        });
        //        break;
        //    case "Manual":
        //        break;
        //    default:
        //        break;
        //}


        //enquiryCarOptions.querySelectorAll(`[data-type="model"]`)

        //cac_util.empty(enquiryMakeSelect);
        //cac_util.empty(enquiryModelSelect);
        //cac_util.empty(enquiryDerivativeSelect);
    }

    function enquiryTransmissionSelected(e) {
        enquiryCar.transmission = e.currentTarget.value;
        filterByTransmission(e.currentTarget.value);
    }
    function enquiryMakeChanged(e) { enquiryMakeGetOptions(); }
    function enquiryModelChanged(e) { enquiryModelGetOptions(); }
    function enquiryDerivativeChanged(e) { enquiryDerivativeGetOptions(); }

    function enquiryCarOtherInput(e) {
        const input = e.currentTarget;
        if (input.value.length > 0) {
            enquiryMakeSelect.selectedIndex = 0;
            enquiryCarNotsure.checked = false;
            enquiryMakeGetOptions();
            vehicleEnquiryFields.make.value = input.value;
            vehicleEnquiryFields.model.value = "";
            vehicleEnquiryFields.derivative.value = "";

            enquiryCar_updateSelectedLabel.makeModel(input.value);
            enquiryCar_updateSelectedLabel.derivative("");
        }
    }

    function enquiryCarOtherBlur(e) {
        const input = e.currentTarget;
        if (enquiryMakeSelect.value.length > 0 || enquiryCarNotsure.checked) { return; }
        if (input.value.length == 0) {
            enquiryCarOptionsInnit();
        }
    }
    function enquiryCarNotsureChanged(e) {
        const cb = e.currentTarget;
        if (cb.checked) {
            enquiryMakeSelect.selectedIndex = 0;
            enquiryMakeSelect.options[0].innerHTML = "Please select&hellip;";
            enquiryCarOther.value = "";
            enquiryMakeGetOptions();
            enquiryForm.elements["Transmission"].value = "Any";
            enquiryCar_updateSelectedLabel.makeModel("I'm not sure yet");
            enquiryCar_updateSelectedLabel.derivative("");
        } else {
            enquiryCarOptionsInnit();
        }
    }

    enquiryTransmissionRadios.forEach((radio) => {
        radio.addEventListener('change', enquiryTransmissionSelected);
    });
    enquiryMakeSelect.addEventListener('change', enquiryMakeChanged);
    enquiryModelSelect.addEventListener('change', enquiryModelChanged);
    enquiryDerivativeSelect.addEventListener('change', enquiryDerivativeChanged);
    enquiryCarOther.addEventListener('input', enquiryCarOtherInput);
    enquiryCarOther.addEventListener('blur', enquiryCarOtherBlur);
    enquiryCarNotsure.addEventListener('change', enquiryCarNotsureChanged);

    function callbackAllowChange(e) {
        const cb = e.currentTarget;
        if (cb.checked) {
            enquiryCallbackDay.selectedIndex = -1;
            enquiryCallbackTime.selectedIndex = -1;
        } else {
            enquiryCallbackDay.selectedIndex = 0;
            enquiryCallbackTime.selectedIndex = 0;
        }
    }
    function callbackDayTimeChange(e) {
        if (enquiryCallbackDay.selectedIndex > -1 || enquiryCallbackTime.selectedIndex > -1) {
            enquiryCallbackNone.checked = false;

            if (enquiryCallbackDay.selectedIndex == -1) {
                enquiryCallbackDay.selectedIndex = 0;
            }
        }
    }

    enquiryCallbackNone.addEventListener('change', callbackAllowChange);
    enquiryCallbackDay.addEventListener('change', callbackDayTimeChange);
    enquiryCallbackTime.addEventListener('change', callbackDayTimeChange);

    function enquiryFormReset(e) {
        setTimeout(function () {
            enquiryCarOptionsInnit();
        }, 500);
    }

    enquiryForm.addEventListener('reset', enquiryFormReset);

    //enquiryCarOptionsInnit();

    return {
        init: enquiryCarOptionsInnit
    }
}
document.addEventListener("DOMContentLoaded", function (e) {
    globalThis.cac_data = (typeof globalThis.cac_data === "undefined") ? {} : globalThis.cac_data;
    cac_data.vehicleEnquiry = new cac_enquiryCarOptions();
    cac_data.vehicleEnquiry.init();
});